import { store } from "./redux/Store"; // Import your Redux store
import { useDispatch } from "react-redux";
import { clearDashboardData } from "./redux/reducers/dashboardSlice";
import { clearNotification } from "./redux/reducers/notificationSlice";
import { clearReport } from "./redux/reducers/reportSlice"


export function GetServiceClear() {
    store.dispatch(clearDashboardData());
    store.dispatch(clearNotification());
    store.dispatch(clearReport());
}
